module.exports = "<div class=\"kuiIcon fa-gear\"></div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guide/views/icon/icon.html
 ** module id = 732
 ** module chunks = 0
 **/